var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showProgressBar
    ? _c("li", { staticClass: "settings-fieldset-interior-item" }, [
        _c("progress", {
          staticClass: "settings-fieldset-interior-item__progressbar",
          attrs: { max: _vm.total },
          domProps: { value: _vm.imported }
        })
      ])
    : _c(
        "li",
        { staticClass: "settings-fieldset-interior-item" },
        [
          _c(
            "label",
            {
              staticClass:
                "settings-fieldset-interior-item__import-button button icon icon-upload",
              attrs: { for: _vm.inputUid }
            },
            [
              _vm._v(
                "\n\t\t" +
                  _vm._s(_vm.$t("calendar", "Import calendar")) +
                  "\n\t"
              )
            ]
          ),
          _vm._v(" "),
          _c("input", {
            ref: "importInput",
            staticClass: "hidden",
            attrs: {
              id: _vm.inputUid,
              type: "file",
              accept: _vm.supportedFileTypes,
              disabled: _vm.disableImport,
              multiple: ""
            },
            on: { change: _vm.processFiles }
          }),
          _vm._v(" "),
          _vm.showImportModal
            ? _c("ImportScreen", {
                attrs: { files: _vm.files },
                on: {
                  "cancel-import": _vm.cancelImport,
                  "import-calendar": _vm.importCalendar
                }
              })
            : _vm._e()
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }